export const BOOKMAKERS_REVIEW = {
  BETTING_AD_PREFIX: "https://bettingads.365scores.com/betboost-filter?"
}